import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_vm._m(0), _c("div", {
    staticClass: "search-global-container --with-legend"
  }, [_c("div", {
    staticClass: "search-container"
  }, [_c("div", {
    staticClass: "search-top-buttons --with-display-mode"
  }, [_c("div", {
    staticClass: "display-mode"
  }, [_c("span", [_vm._v("Display by order")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.displayBySupplier,
      callback: function callback($$v) {
        _vm.displayBySupplier = $$v;
      },
      expression: "displayBySupplier"
    }
  }), _c("span", [_vm._v("Display by supplier")])], 1), _c("div", [_vm.canManageSupplierPrices ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.importSupplierPrices();
      }
    }
  }, [_c(VIcon, {
    staticClass: "--margin-right",
    attrs: {
      dark: ""
    }
  }, [_vm._v("fas fa-file-upload")]), _vm._v(" Import supplier prices ")], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.isExporting
    },
    on: {
      click: function click($event) {
        return _vm.exportSourcing();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-export")]), _vm._v(" Export ")], 1)], 1)]), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      placeholder: "Search for an order reference, sku, product or producer",
      solo: "",
      "hide-details": "auto",
      "append-icon": "fa-search",
      loading: _vm.datatableLoading,
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.filters.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.filters.label,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "label", $$v);
      },
      expression: "filters.label"
    }
  })], 1)])]), _c("div", {
    staticClass: "search-legend --closed"
  }, [_vm._m(1), _c("div", {
    staticClass: "search-legend-closed-label",
    on: {
      click: function click($event) {
        return _vm.toggleLegend();
      }
    }
  }, [_vm._v("Legend")]), _c("div", {
    staticClass: "search-legend-closer"
  }, [_c(VIcon, {
    attrs: {
      title: "Close legend"
    },
    on: {
      click: function click($event) {
        return _vm.toggleLegend();
      }
    }
  }, [_vm._v("fa-times")])], 1), _c("div", {
    staticClass: "search-legend-opener"
  }, [_c(VIcon, {
    attrs: {
      title: "See legend"
    },
    on: {
      click: function click($event) {
        return _vm.toggleLegend();
      }
    }
  }, [_vm._v("fa-plus")])], 1)])]), _c("div", {
    staticClass: "actions-btn"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.expandAllPanels();
      }
    }
  }, [_vm._v(" Expand All ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.collapseAllPanels();
      }
    }
  }, [_vm._v(" Collapse All ")])], 1), !_vm.displayBySupplier && !_vm.displayByWinery ? _c(VDataTable, {
    staticClass: "datatable-order overflow-unset --no-header-mobile --no-hover",
    attrs: {
      "item-key": "id_order",
      headers: _vm.datatableHeaders,
      items: _vm.datatableItems,
      "items-per-page": -1,
      loading: _vm.datatableLoading,
      "loading-text": "It may take a few moment, please wait...",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.order",
      fn: function fn(_ref) {
        var _item$parentContainer;
        var item = _ref.item;
        return [_c("div", {
          staticClass: "order-section"
        }, [_c("div", {
          staticClass: "order-section-infos"
        }, [_c("i", {
          staticClass: "fas fa-arrow-alt-circle-down sourcing-icon",
          class: item.orderCssClassStatus
        }), _c("router-link", {
          attrs: {
            to: _vm.goToOrder(item.id_order),
            target: "_blank"
          }
        }, [_c("span", {
          staticClass: "bold"
        }, [_vm._v(" " + _vm._s(item.type == _vm.orderTypes.CONTAINER ? "Container #".concat(item.reference_order.shorterReference()) : "#".concat(item.reference_order.shorterReference())) + " ")])]), ((_item$parentContainer = item.parentContainerOrder) === null || _item$parentContainer === void 0 ? void 0 : _item$parentContainer.id_order) > 0 ? _c("div", {
          staticClass: "text-smaller"
        }, [_c("router-link", {
          attrs: {
            to: _vm.goToOrder(item.parentContainerOrder.id_order),
            target: "_blank"
          }
        }, [_vm._v(" on container #" + _vm._s(item.parentContainerOrder.reference_order.shorterReference()) + " ")])], 1) : _vm._e(), _c("div", [_vm._v("(" + _vm._s(_vm._f("formatDate")(item.date_order)) + ")")])], 1)])];
      }
    }, {
      key: "item.itemsOrder",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticClass: "pa-1"
        }, [_c(VExpansionPanels, {
          staticClass: "expansion-panels",
          attrs: {
            value: _vm.panelsOpened
          }
        }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v(" Item" + _vm._s(item.items.length > 1 ? "s" : "") + " (" + _vm._s(item.items.length) + ") ")]), _c(VExpansionPanelContent, [_c("div", {
          staticClass: "panel-content"
        }, _vm._l(item.items, function (orderItem) {
          return _c("div", {
            key: orderItem.id_item,
            staticClass: "panel-row elevation-1"
          }, [_c("div", {
            staticClass: "wine-infos"
          }, [_c("div", [orderItem.associatedPurchaseOrders.length > 0 ? _c("i", {
            staticClass: "fas fa-arrow-alt-circle-down sourcing-icon",
            class: _vm.getOrderItemStatus(orderItem)
          }) : _c("i", {
            staticClass: "fas fa-arrow-alt-circle-down status-icon danger"
          })]), _c("span", {
            staticClass: "item-qty"
          }, [_vm._v(_vm._s(orderItem.quantity) + " b.")]), _c("div", {
            staticClass: "item-display-infos"
          }, [_c("router-link", {
            staticClass: "router-link",
            attrs: {
              to: _vm.goToProductDetails(orderItem.wine),
              target: "_blank"
            }
          }, [_c("span", {
            staticClass: "item-name bold"
          }, [_vm._v(_vm._s(orderItem.wine.display_name))])]), _c("span", {
            staticClass: "item-sku"
          }, [_vm._v(_vm._s(orderItem.wine.sku))]), _c(VBtn, {
            staticClass: "dfwa-btn --small-2 px-1",
            attrs: {
              rounded: true
            },
            on: {
              click: function click($event) {
                return _vm.openSupplierPrices(orderItem.wine.id_wine);
              }
            }
          }, [_vm._v(" sup.prices ")])], 1)]), _c("div", {
            staticClass: "purchase-order-infos"
          }, [orderItem.associatedPurchaseOrders.length ? _c("div", _vm._l(orderItem.associatedPurchaseOrders, function (po) {
            return _c("div", {
              key: po.id
            }, [_c("div", {
              staticClass: "purchase-order-infos-row"
            }, [_c("i", {
              class: [_vm.getPoItemStatus(po, orderItem.quantity)]
            }), _c("span", {
              staticClass: "info-row-quantity"
            }, [_vm._v(" " + _vm._s(po.quantity) + " b. / " + _vm._s(orderItem.quantity) + " b. ")]), _c("router-link", {
              staticClass: "info-row-link",
              attrs: {
                to: _vm.goToPurchaseOrder(po),
                target: "_blank"
              }
            }, [_c("span", [_vm._v("#" + _vm._s(po.number))])])], 1)]);
          }), 0) : _c("div", {
            staticClass: "purchase-order-infos-row"
          }, [_c("i", {
            staticClass: "fas fa-times-circle danger"
          }), _vm._v(" There is no associated purchase order ")])]), _c("div", {
            staticClass: "comment-infos"
          }, [_vm.canManagePos ? _c("SourcingItemData", {
            attrs: {
              orderItem: orderItem
            },
            on: {
              quotationStatusUpdated: _vm.itemRowQuotationStatusUpdated,
              commentUpdated: _vm.itemRowCommentUpdated
            }
          }) : _vm._e()], 1)]);
        }), 0)])], 1)], 1)], 1)];
      }
    }], null, true)
  }) : _vm._e(), _vm.displayByWinery ? _c(VDataTable, {
    staticClass: "datatable-winery overflow-unset",
    attrs: {
      "item-key": "id_item",
      headers: _vm.datatableHeadersByWinery,
      items: _vm.datatableWineryItems.wineries,
      "items-per-page": -1,
      loading: _vm.datatableLoading,
      "loading-text": "It may take a few moment, please wait...",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.winery",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "sticky-title"
        }, [_vm._v(" " + _vm._s(item.name) + " ")])];
      }
    }, {
      key: "item.items",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "pa-1"
        }, [_c(VExpansionPanels, {
          staticClass: "expansion-panels",
          attrs: {
            value: _vm.panelsOpened
          }
        }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v(" Item" + _vm._s(_vm.getItemsByWinery(item).length > 1 ? "s" : "") + " (" + _vm._s(_vm.getItemsByWinery(item).length) + ") ")]), _c(VExpansionPanelContent, [_c("div", {
          staticClass: "panel-content"
        }, _vm._l(_vm.getItemsByWinery(item), function (itemRow, index) {
          return _c("div", {
            key: itemRow.id_item,
            staticClass: "panel-row elevation-1",
            class: _vm.isPreviousSame(_vm.getItemsByWinery(item)[index - 1], itemRow) ? "related-to-previous" : "mt-6"
          }, [_c("div", {
            staticClass: "wine-infos"
          }, [_c("div", [itemRow.associatedPurchaseOrders.length > 0 ? _c("i", {
            staticClass: "fas fa-arrow-alt-circle-down sourcing-icon",
            class: _vm.getWineryItemStatus(itemRow)
          }) : _c("i", {
            staticClass: "fas fa-arrow-alt-circle-down status-icon danger"
          })]), _c("span", {
            staticClass: "item-qty"
          }, [_vm._v(_vm._s(itemRow.quantity) + " b.")]), _c("div", {
            staticClass: "item-display-infos"
          }, [_c("router-link", {
            staticClass: "router-link",
            attrs: {
              to: _vm.goToProductDetails(itemRow.wine)
            }
          }, [_c("span", {
            staticClass: "item-name bold"
          }, [_vm._v(_vm._s(itemRow.wine.display_name))])]), _c("span", {
            staticClass: "item-sku"
          }, [_vm._v(_vm._s(itemRow.wine.sku))]), _c("div", [_c("router-link", {
            attrs: {
              to: _vm.goToOrder(itemRow.id_order),
              target: "_blank"
            }
          }, [_vm._v(" " + _vm._s(item.type == _vm.orderTypes.CONTAINER ? "Container CM#".concat(itemRow.id_order) : "CM#".concat(itemRow.id_order)) + " ")])], 1)], 1)]), _c("div", {
            staticClass: "purchase-order-infos"
          }, [itemRow.associatedPurchaseOrders.length ? _c("div", _vm._l(itemRow.associatedPurchaseOrders, function (po) {
            return _c("div", {
              key: po.id
            }, [_c("div", {
              staticClass: "purchase-order-infos-row"
            }, [_c("i", {
              class: [_vm.getPoItemStatus(po, itemRow.quantity)]
            }), _c("span", {
              staticClass: "info-row-quantity"
            }, [_vm._v(" " + _vm._s(po.quantity) + " b. / " + _vm._s(itemRow.quantity) + " b. ")]), _c("router-link", {
              staticClass: "info-row-link",
              attrs: {
                to: _vm.goToPurchaseOrder(po),
                target: "_blank"
              }
            }, [_c("span", [_vm._v("#" + _vm._s(po.number))])])], 1)]);
          }), 0) : _c("div", {
            staticClass: "purchase-order-infos-row"
          }, [_c("i", {
            staticClass: "fas fa-times-circle danger"
          }), _vm._v(" There is no associated purchase order ")])]), _c("div", {
            staticClass: "comment-infos"
          }, [_vm.canManagePos ? _c("SourcingItemData", {
            attrs: {
              orderItem: itemRow
            },
            on: {
              quotationStatusUpdated: _vm.itemRowQuotationStatusUpdated,
              commentUpdated: _vm.itemRowCommentUpdated
            }
          }) : _vm._e()], 1)]);
        }), 0)])], 1)], 1)], 1)];
      }
    }], null, true)
  }) : _vm._e(), _vm.displayBySupplier ? _c("SourcingSupplierTable", {
    attrs: {
      datatableLoading: _vm.datatableLoading,
      itemsProps: _vm.datatableItems,
      panelsOpened: _vm.panelsOpened
    },
    on: {
      "update:panelsOpened": function updatePanelsOpened($event) {
        _vm.panelsOpened = $event;
      }
    }
  }) : _vm._e(), _vm.isWineSupplierPriceModalShown ? _c("WineSupplierPriceModal", {
    ref: "wineSupplierPriceModalRef",
    attrs: {
      wineId: _vm.currentWineId
    },
    on: {
      closed: _vm.closeSupplierPrices
    }
  }) : _vm._e(), _vm.isImportSupplierPricesShown ? _c("ImportSupplierPrices", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    model: {
      value: _vm.isImportSupplierPricesShown,
      callback: function callback($$v) {
        _vm.isImportSupplierPricesShown = $$v;
      },
      expression: "isImportSupplierPricesShown"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container-centered"
  }, [_c("h1", [_vm._v("Sourcing")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "search-legend__main-content"
  }, [_c("div", {
    staticClass: "search-legend-items"
  }, [_c("div", {
    staticClass: "mb-2"
  }, [_vm._v("Item & order status")]), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("div", {
    staticClass: "mvtstock-icon"
  }, [_c("i", {
    staticClass: "fas fa-arrow-alt-circle-down danger"
  })])]), _c("div", [_vm._v("No PO associated")])]), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("div", {
    staticClass: "mvtstock-icon"
  }, [_c("i", {
    staticClass: "fas fa-arrow-alt-circle-down warning"
  })])]), _c("div", [_vm._v("There are POs but not fully received")])]), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("div", {
    staticClass: "mvtstock-icon"
  }, [_c("i", {
    staticClass: "fas fa-arrow-alt-circle-down success"
  })])]), _c("div", [_vm._v("all POs fulfill order")])]), _c("div", {
    staticClass: "mb-2 mt-2"
  }, [_vm._v("PO status")]), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("div", {
    staticClass: "mvtstock-icon"
  }, [_c("i", {
    staticClass: "fas fa-times-circle danger"
  })])]), _c("div", [_vm._v("No PO associated to item")])]), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("div", {
    staticClass: "mvtstock-icon"
  }, [_c("i", {
    staticClass: "fas fa-hourglass-half danger"
  })])]), _c("div", [_vm._v("PO is still in draft")])]), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("div", {
    staticClass: "mvtstock-icon"
  }, [_c("i", {
    staticClass: "fas fa-hourglass-half warning"
  })])]), _c("div", [_vm._v("PO is awaiting reception")])]), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("div", {
    staticClass: "mvtstock-icon"
  }, [_c("i", {
    staticClass: "fas fa-check warning"
  })])]), _c("div", [_vm._v("PO is awaiting receipt, but not fullfill the order item")])]), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("div", {
    staticClass: "mvtstock-icon"
  }, [_c("i", {
    staticClass: "fas fa-check success"
  })])]), _c("div", [_vm._v("PO fulfill the order and has been received")])])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };